module.exports = __webpack_public_path__ + "img/how-to.becaa524.svg";